import { Paragraph, Heading } from '@nrk/dh-feature-components'
import * as style from './index.css'
import * as preact from 'preact'

const { h } = preact

export const Ingress = ({ ingress }) => {
  const mappedIngress =
    ingress &&
    ingress.map(item => {
      switch (item.type) {
        case 'title':
          return null
        case 'text':
          return (
            <Paragraph
              key={item.value.split('.')[0]}
              html={item.value.replace('\n', '<br>').trim()}
              className={style.ingress__paragraph}
            />
          )
        default:
          return JSON.stringify(item.value, null, 2)
      }
    })
  return <div className={style.ingress__wrapper}>{mappedIngress}</div>
}



// WEBPACK FOOTER //
// ./src/v1/components/Header/Ingress/index.tsx